import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7be3c9b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search_div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活动名称：", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "状态：", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查找")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("数据")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_10 = { class: "flex_from" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cents_infos" }, [
  /*#__PURE__*/_createElementVNode("p", null, "活动背景图："),
  /*#__PURE__*/_createElementVNode("a", {
    download: "",
    href: "https://wximg.ycvod.cn/yinchuang/peelerCurrency/themeSix/luck_draw.png"
  }, "下载示例")
], -1))
const _hoisted_14 = { class: "res_div" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "edit_bj" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "eit_p" }, "更换背景图", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "尺寸：750*1624，", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "支持jpg/png格式，", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "大小2M以内", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "奖品设置：（建议按奖品价值大小，从上往下排序）", -1))
const _hoisted_22 = { class: "flex_infos" }
const _hoisted_23 = {
  class: "tables",
  border: "0",
  cellspacing: "0"
}
const _hoisted_24 = { class: "headers" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "奖品图片", -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode("优惠券：用户中奖后系统自动发送到用户账户，无需领取；优惠券请先提前在云管系统创建")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode("谢谢参与：抽中后提示用户未中奖")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode("非优惠券奖品：请输入领奖说明，方便客人了解如何领奖")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("奖品类型")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "奖品名称", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "奖品数量", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "中奖概率", -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode("优惠券：用户中奖后系统自动发送到用户账户，无需领取")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode("非优惠券奖品：请输入领奖说明，方便客人了解如何领奖")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("领奖说明")
const _hoisted_40 = ["src"]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 3 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("% ")
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "show_div" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "cont_view" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "luck_cj",
  src: "https://wximg.ycvod.cn/yinchuang/peelerCurrency/themeSix/luck_cj.png"
}, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "luci_item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://wximg.ycvod.cn/yinchuang/peelerCurrency/themeSix/luck_ing.png",
    class: "luck_tcj"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "luck_num" }, "剩余1次")
], -1))
const _hoisted_52 = { class: "luci_item" }
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "act_name" }
const _hoisted_55 = {
  key: 1,
  class: "luci_item"
}
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "act_name" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_btm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "玩法规则"),
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn_my" }, "我的奖品")
], -1))
const _hoisted_59 = { class: "dialog-footer" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_61 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_62 = { class: "count_div" }
const _hoisted_63 = { class: "item_count" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "浏览人数", -1))
const _hoisted_65 = { class: "item_count" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "抽奖人数", -1))
const _hoisted_67 = { class: "item_count" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "中奖人数", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "zjmx" }, "奖品中奖明细", -1))
const _hoisted_70 = { class: "zjlis" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用户中奖明细", -1))

import { ref, getCurrentInstance, onMounted } from 'vue'
  import pageTitle from '@/components/pageTitle.vue';
  import { ElMessage, ElMessageBox } from 'element-plus';
  import { drawActivityList, drawAddDraw, getCouponList, getDrawDetail, editDraw, delDraw, getDrawData, getPrizeDetail, getPrizeList, getUserDrawList } from '@/axios/smartMarket';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'luckManager',
  setup(__props) {

  let names = ref('')
  let status = ref(0)
  let tableData = ref([])
  let showLuck = ref(false)
  let form = ref({
    background:'',
    id:'',
    status: 1,
    draw_name: '',
    can_draw_num: '',
    describe: ''
  })
  let timeRange = ref(['',''])
  let oldBackground = ref('https://wximg.ycvod.cn/yinchuang/peelerCurrency/themeSix/luck_draw.png')
  let drawer = ref(false)
  let list = ref([
    {name:'一等奖',image:'',type:2,prize_name:'',stock:'',win_rate:'',directions:'',level:1,coupon_id:''},
    {name:'二等奖',image:'',type:2,prize_name:'',stock:'',win_rate:'',directions:'',level:2,coupon_id:''},
    {name:'三等奖',image:'',type:2,prize_name:'',stock:'',win_rate:'',directions:'',level:3,coupon_id:''},
    {name:'四等奖',image:'',type:2,prize_name:'',stock:'',win_rate:'',directions:'',level:4,coupon_id:''},
    {name:'五等奖',image:'',type:2,prize_name:'',stock:'',win_rate:'',directions:'',level:5,coupon_id:''},
    {name:'六等奖',image:'',type:2,prize_name:'',stock:'',win_rate:'',directions:'',level:6,coupon_id:''},
    {name:'七等奖',image:'',type:2,prize_name:'',stock:'',win_rate:'',directions:'',level:7,coupon_id:''},
    {name:'八等奖',image:'',type:2,prize_name:'',stock:'',win_rate:'',directions:'',level:8,coupon_id:''}
  ])
  let allCoupon = ref([]);
  let { proxy } = getCurrentInstance() as any;
  let drawInfo = ref({})
  let prizeDetail = ref([])
  let prizeList = ref([])
  let userDrawList = ref([])
  let checkUser = ref('')
  let drawId = ref<string|number>('')

  onMounted(()=>{
    getList()
    getCoupon();
  })
  function getList(){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    drawActivityList({
      brand_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id,
      company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id,
      status: status.value,
      draw_name: names.value
    }).then((data:any)=>{
      tableData.value = data;
    }).catch((err:any)=>{})
  }
  //抽奖数据
  function showData(id:number){
    drawId.value = id;
    drawer.value = true;
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    getDrawData({
      draw_id: id,
      brand_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id,
      company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id
    }).then((data:any) => {
      drawInfo.value = data;
    }).catch((err:any)=>{})

    getPrizeDetail({
      draw_id: id,
      brand_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id,
      company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id
    }).then((data:any) => {
      prizeDetail.value = data;
    }).catch((err:any)=>{})

    getPrizeList({
      draw_id: id,
      brand_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id,
      company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id
    }).then((data:any) => {
      prizeList.value = data;
      checkUser.value = data[0]?data[0].id:'';
      getUserDrawLists();
    }).catch((err:any)=>{})
  }
  //中奖明细
  function getUserDrawLists(){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    getUserDrawList({
      prize_id: checkUser.value,
      draw_id: drawId.value,
      brand_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id,
      company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id
    }).then((data:any) => {
      userDrawList.value = data;
    }).catch((err:any)=>{})
  }
  //删除
  function delLuck(id:number){
    ElMessageBox.confirm('是否删除该活动').then(() => {
      delDraw({
        draw_id: id
      }).then((data:any) => {
        ElMessage('删除成功')
        getList()
      }).catch((err:any)=>{})
    }).catch(() => {
      
    })
  }
  function checkCoupon(id:number,num:number){
    allCoupon.value.some((item:any) => {
      if(item.couponid == id){
        list.value[num].prize_name = item.title
        return true;
      }
    })
  }
  //获取优惠券
  function getCoupon(){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    getCouponList({
      company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id,
      page: 1,
      page_size: 50
    }).then((data:any) => {
      let newarr:any = [], nowDate = new Date().getTime();
      data.map((item:any) => {
        let endTime = new Date(item.end_time).getTime();
        if(nowDate < endTime){
          newarr.push(item)
        }
      })
      allCoupon.value = newarr;
    }).catch((err:any)=>{})
    
  }
  //弹窗点击
  function queryClick(){
    if(!form.value.draw_name){
      ElMessage('请输入活动名称')
      return false;
    }
    if(!timeRange.value[0] && !timeRange.value[1]){
      ElMessage('请选择活动时间')
      return false;
    }
    if(!form.value.can_draw_num){
      ElMessage('请输入可抽奖次数')
      return false;
    }
    if(!form.value.describe){
      ElMessage('请输入活动规则')
      return false;
    }
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '')
    let arr:any = [];
    let i=0, win_rate=0, xs=0, prizeName=0;
    list.value.map((item:any)=>{
      let obj = JSON.parse(JSON.stringify(item));
      console.log(obj)
      delete obj.name;
      arr.push(obj);
      let xsw = (obj.win_rate+'').split('.')[1];
      if(xsw){
        xs = xsw.length>2 ? xs+1 : xs;
      }
      win_rate = win_rate + Number(obj.win_rate);
      if(!obj.image){
        i++;
      }
      if(!obj.prize_name){
        prizeName++;
      }

    })
    if(i>0){
      ElMessage('请选择奖品图片');
      return false;
    }
    if(prizeName>0){
      ElMessage('请将奖品设置完整');
      return false;
    }
    if(xs>0){
      ElMessage('小数位数最多2位');
      return false;
    }
    if(win_rate!=100){
      ElMessage('中奖概率总和必须为100%');
      return false;
    }
    
    if(form.value.id){
      editDraw({
        id: form.value.id,
        brand_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id,
        company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id,
        status: form.value.status,
        draw_name: form.value.draw_name,
        star_time: timeRange.value[0],
        end_time: timeRange.value[1],
        can_draw_num: form.value.can_draw_num,
        describe: form.value.describe,
        background: form.value.background,
        prize_list: JSON.stringify(arr)
      }).then((data:any) => {
        ElMessage('编辑成功')
        getList()
        closeInfo();
      }).catch((err:any)=>{})
    }
    else{
      drawAddDraw({
        brand_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id,
        company_id: aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id,
        status: form.value.status,
        draw_name: form.value.draw_name,
        star_time: timeRange.value[0],
        end_time: timeRange.value[1],
        can_draw_num: form.value.can_draw_num,
        describe: form.value.describe,
        background: form.value.background,
        prize_list: JSON.stringify(arr)
      }).then((data:any) => {
        ElMessage('新增成功')
        getList();
        closeInfo();
      }).catch((err:any)=>{})
    }
  }
  function closeInfo(){
    showLuck.value = false;
    form.value = {
      background:'',
      id:'',
      status: 1,
      draw_name: '',
      can_draw_num: '',
      describe: ''
    };
    timeRange.value = ['','']
    list.value = [
      {name:'一等奖',image:'',type:1,prize_name:'',stock:'',win_rate:'',directions:'',level:1,coupon_id:''},
      {name:'二等奖',image:'',type:1,prize_name:'',stock:'',win_rate:'',directions:'',level:2,coupon_id:''},
      {name:'三等奖',image:'',type:1,prize_name:'',stock:'',win_rate:'',directions:'',level:3,coupon_id:''},
      {name:'四等奖',image:'',type:1,prize_name:'',stock:'',win_rate:'',directions:'',level:4,coupon_id:''},
      {name:'五等奖',image:'',type:1,prize_name:'',stock:'',win_rate:'',directions:'',level:5,coupon_id:''},
      {name:'六等奖',image:'',type:1,prize_name:'',stock:'',win_rate:'',directions:'',level:6,coupon_id:''},
      {name:'七等奖',image:'',type:1,prize_name:'',stock:'',win_rate:'',directions:'',level:7,coupon_id:''},
      {name:'八等奖',image:'',type:1,prize_name:'',stock:'',win_rate:'',directions:'',level:8,coupon_id:''}
    ]
  }

  //下载二维码
  function downs(id:number){
    let aci = JSON.parse(sessionStorage.getItem('accountInfo') || '');
    let compid = aci.company_list[sessionStorage.getItem('checkCompany') || 0].company_id;
    let brandid = aci.company_list[sessionStorage.getItem('checkCompany') || 0].brand_id;
    return `${proxy.$downUrl}/admin/qrcode/createDrawQrcode?parent_id=${brandid}&company_id=${compid}&draw_id=${id}`;
  }
  //新增编辑
  function showLuckDia(val?:number){
    showLuck.value = true;
    if(val){
      getDrawDetail({
        draw_id: val
      }).then((data:any)=>{
        form.value = data;
        timeRange.value[0] = data.star_time
        timeRange.value[1] = data.end_time;
        list.value.map(item => {
          data.prize_list.some((citem:any) => {
            if(citem.level == item.level){
              citem.directions = citem.directions.replace('n','\n');
              item = Object.assign(item,citem);
              return true;
            }
          })
        })
        
      }).catch((err:any)=>{})
    }
    else{
      form.value.background = oldBackground.value;
    }
  }
  //抽奖类型选择
  function typeClick(type:number,num:number){
    if(type == 3){
      list.value[num].prize_name = '谢谢参与'
    }
  }
  //图片上传
  function beforeAvatarUpload(val:any,num:number){
    console.log(val)
    if(val.type.includes('jpeg') || val.type.includes('jpg') || val.type.includes('png')){
      let formdata = new FormData();
      formdata.append('file',val);
      formdata.append('project','om');
      formdata.append('modular','peelerCurrency');
      formdata.append('file_type',val.type.includes('image')?'image':'video');
      let urls = `${proxy?.$uploadUrl}/yc_upload/upload/uploads`;
      let xml = new window.XMLHttpRequest();
      xml.open('post',urls,true)
      xml.send(formdata);
      xml.onreadystatechange = function() {
        if(xml.readyState==4 && xml.status==200){
          let infos = JSON.parse(xml.response);
          console.log(infos)
          if(num == -1){
            form.value.background = infos.data.url;
          }
          else{
            list.value[num].image = infos.data.url;
          }
          // form.value.friends_share_pic = infos.data.url;
        }
      }
    }
    else{
      ElMessage('请选择推荐格式文件')
    }
    return false;
  }
  //使用默认背景图
  function returnBack(){
    form.value.background = oldBackground.value;
  }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(pageTitle, { title: "九宫格抽奖活动" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_input, {
        modelValue: _unref(names),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(names) ? (names).value = $event : names = $event)),
        clearable: ""
      }, null, 8, ["modelValue"]),
      _hoisted_3,
      _createVNode(_component_el_select, {
        modelValue: _unref(status),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event)),
        clearable: "",
        filterable: "",
        placeholder: "请选择状态"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "启用",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "停用",
            value: -1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: getList
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (showLuckDia()))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: _unref(tableData),
      border: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "draw_name",
          label: "活动名称"
        }),
        _createVNode(_component_el_table_column, { label: "状态" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.status==1?'启用':'停用'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "star_time",
          label: "开始时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "end_time",
          label: "结束时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "创建时间"
        }),
        _createVNode(_component_el_table_column, {
          prop: "user_name",
          label: "创建人"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "360px"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("a", {
              href: downs(scope.row.id),
              class: "down_a"
            }, "下载二维码", 8, _hoisted_6),
            _createVNode(_component_el_button, {
              text: "",
              type: "primary",
              onClick: ($event: any) => (showData(scope.row.id))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              text: "",
              type: "primary",
              onClick: ($event: any) => (showLuckDia(scope.row.id))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              text: "",
              type: "primary",
              onClick: ($event: any) => (delLuck(scope.row.id))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(showLuck),
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(showLuck) ? (showLuck).value = $event : showLuck = $event)),
      title: _unref(form).id?'编辑活动':'新增活动',
      width: "1500px",
      onClose: _cache[10] || (_cache[10] = ($event: any) => (closeInfo()))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_59, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: queryClick
          }, {
            default: _withCtx(() => [
              _hoisted_60
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (closeInfo()))
          }, {
            default: _withCtx(() => [
              _hoisted_61
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_form, {
            model: _unref(form),
            "label-width": "140px",
            "label-position": "left",
            ref: "brandDiaForm",
            class: "brand_from"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "活动名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).draw_name,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).draw_name) = $event)),
                    placeholder: "请输入活动名称"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "活动时间" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _unref(timeRange),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(timeRange) ? (timeRange).value = $event : timeRange = $event)),
                    type: "datetimerange",
                    "value-format": "YYYY-MM-DD HH:mm:ss",
                    "range-separator": "至",
                    "start-placeholder": "开始时间",
                    "end-placeholder": "结束时间"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "每人每天可抽奖次数" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _unref(form).can_draw_num,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).can_draw_num) = $event)),
                    min: 1
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "活动状态",
                prop: "is_enable"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: _unref(form).status,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).status) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: 1 }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: -1 }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "活动规则" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).describe,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).describe) = $event)),
                    type: "textarea"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              class: "sl_img",
              src: _unref(form).background
            }, null, 8, _hoisted_15),
            _createVNode(_component_el_icon, {
              class: "del_icon",
              onClick: returnBack
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_upload, {
                class: "avatar-uploader",
                action: "",
                "show-file-list": false,
                "before-upload": (val) => beforeAvatarUpload(val,-1)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, {
                    class: "el-icon--upload",
                    size: 60
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_upload_filled)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["before-upload"]),
              _hoisted_17,
              _hoisted_18,
              _hoisted_19,
              _hoisted_20
            ])
          ])
        ]),
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("table", _hoisted_23, [
            _createElementVNode("tr", _hoisted_24, [
              _hoisted_25,
              _hoisted_26,
              _createElementVNode("td", null, [
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  placement: "top"
                }, {
                  content: _withCtx(() => [
                    _hoisted_27,
                    _hoisted_28,
                    _hoisted_29,
                    _hoisted_30,
                    _hoisted_31
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _hoisted_32,
                      _createVNode(_component_el_icon, {
                        size: 16,
                        class: "ts"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Warning)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _createElementVNode("td", null, [
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  placement: "top"
                }, {
                  content: _withCtx(() => [
                    _hoisted_36,
                    _hoisted_37,
                    _hoisted_38
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _hoisted_39,
                      _createVNode(_component_el_icon, {
                        size: 16,
                        class: "ts"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Warning)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(item.name), 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_el_upload, {
                    class: "avatar-uploader",
                    action: "",
                    "show-file-list": false,
                    "before-upload": (val) => beforeAvatarUpload(val,index)
                  }, {
                    default: _withCtx(() => [
                      (!item.image)
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 0,
                            class: "up_icon"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: item.image,
                            class: "img_act"
                          }, null, 8, _hoisted_40))
                    ]),
                    _: 2
                  }, 1032, ["before-upload"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_el_select, {
                    modelValue: item.type,
                    "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                    onChange: ($event: any) => (typeClick(item.type,index)),
                    class: "tb_select"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "优惠券",
                        value: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "非优惠券",
                        value: 2
                      }),
                      _createVNode(_component_el_option, {
                        label: "谢谢参与",
                        value: 3
                      })
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]),
                _createElementVNode("td", null, [
                  (item.type==1)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        modelValue: item.coupon_id,
                        "onUpdate:modelValue": ($event: any) => ((item.coupon_id) = $event),
                        onChange: ($event: any) => (checkCoupon(item.coupon_id,index)),
                        placeholder: "请选择优惠券",
                        class: "jp_inp"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allCoupon), (citem) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: citem.title,
                              value: citem.couponid
                            }, null, 8, ["label", "value"]))
                          }), 256))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
                    : (item.type==3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, "————"))
                      : (_openBlock(), _createBlock(_component_el_input, {
                          key: 2,
                          modelValue: item.prize_name,
                          "onUpdate:modelValue": ($event: any) => ((item.prize_name) = $event),
                          placeholder: "请输入奖品名称",
                          maxlength: "12",
                          class: "jp_inp"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])),
                  (item.type==2)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_42, _toDisplayString(item.prize_name.length) + "/12", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  (item.type==3)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, "————"))
                    : (_openBlock(), _createBlock(_component_el_input, {
                        key: 1,
                        modelValue: item.stock,
                        "onUpdate:modelValue": ($event: any) => ((item.stock) = $event),
                        placeholder: "请输入奖品数量",
                        class: "tb_input"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_el_input, {
                    modelValue: item.win_rate,
                    "onUpdate:modelValue": ($event: any) => ((item.win_rate) = $event),
                    class: "tb_input"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _hoisted_44
                ]),
                _createElementVNode("td", null, [
                  (item.type==1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, "中奖后自动到账"))
                    : (item.type==3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_46, "抽中后提示未中奖"))
                      : (_openBlock(), _createBlock(_component_el_input, {
                          key: 2,
                          modelValue: item.directions,
                          "onUpdate:modelValue": ($event: any) => ((item.directions) = $event),
                          type: "textarea",
                          placeholder: "请输入领奖说明"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("img", {
              class: "show_img",
              src: _unref(form).background
            }, null, 8, _hoisted_48),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (index==4)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_51,
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("img", {
                            class: "img_act",
                            src: item.image
                          }, null, 8, _hoisted_53),
                          _createElementVNode("div", _hoisted_54, _toDisplayString(item.prize_name), 1)
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("img", {
                          class: "img_act",
                          src: item.image
                        }, null, 8, _hoisted_56),
                        _createElementVNode("div", _hoisted_57, _toDisplayString(item.prize_name), 1)
                      ]))
                ], 64))
              }), 256))
            ]),
            _hoisted_58
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: _unref(drawer),
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(drawer) ? (drawer).value = $event : drawer = $event)),
      title: _unref(drawInfo).draw_name,
      direction: "rtl"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("p", null, _toDisplayString(_unref(drawInfo).browse_num), 1),
            _hoisted_64
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("p", null, _toDisplayString(_unref(drawInfo).draw_num), 1),
            _hoisted_66
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("p", null, _toDisplayString(_unref(drawInfo).draw_win_num), 1),
            _hoisted_68
          ])
        ]),
        _hoisted_69,
        _createVNode(_component_el_table, {
          data: _unref(prizeDetail),
          border: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "prize_name",
              label: "奖品名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "total",
              label: "总数量"
            }),
            _createVNode(_component_el_table_column, {
              prop: "draw_num",
              label: "抽中数量"
            }),
            _createVNode(_component_el_table_column, {
              prop: "stock",
              label: "剩余数量"
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_70, [
          _hoisted_71,
          _createVNode(_component_el_select, {
            modelValue: _unref(checkUser),
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(checkUser) ? (checkUser).value = $event : checkUser = $event)),
            onChange: _cache[12] || (_cache[12] = ($event: any) => (getUserDrawLists()))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(prizeList), (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  label: item.prize_name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 256))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_el_table, {
          data: _unref(userDrawList),
          border: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "member_name",
              label: "会员名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "phone",
              label: "会员手机号"
            }),
            _createVNode(_component_el_table_column, {
              prop: "prize_name",
              label: "中奖奖品"
            }),
            _createVNode(_component_el_table_column, {
              prop: "draw_time",
              label: "中奖时间"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})